<template>
    <v-layout pa-0 ma-0 row justify-space-between v-if="device && device.state">
        <v-flex xs6 class="d-inline-flex align-center">
            <div v-if="showLocation" class="note-row text-left ma-0"> {{device.location}} </div>
        </v-flex>
        <v-flex xs6 class="d-inline-flex justify-end align-center devices-list__block__status">
            <v-tooltip
                top
                content-class="arrow-down"
                v-model="showBattery"
                v-if="device.state.power == 'battery' && device.state.battery != null"
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        class="d-inline-flex"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop.prevent="showBattery = true"
                    >
                        <div v-html="require(`!html-loader!@/assets/icons/battery/${power}.svg`)" class="size-24" />
                    </div>
                </template>
                <span class="main-text dark-grey-text">{{device.state.battery}}%</span>
            </v-tooltip>
            <div
                v-else-if="device.state.power == 'mains'"
                v-html="require(`!html-loader!@/assets/icons/battery/plug.svg`)"
                class="size-20"
            />
            <v-tooltip top content-class="arrow-down" v-model="show">
                <template v-slot:activator="{ on, attrs }">
                    <div
                        class="d-inline-flex"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop.prevent="show = true"
                    >
                        <div class="status-marker ml-2">
                            <div :class="device.online ? 'green-color' : 'red-color'"></div>
                        </div>
                    </div>
                </template>
                <span class="main-text dark-grey-text">{{device.online ? "online" : "offline"}}</span>
            </v-tooltip>
            <div
                v-if="edit"
                v-html="require('!html-loader!@/assets/icons/edit_icon.svg')"
                class="d-inline-flex ml-2 size-24"
                @click.stop.prevent="openEditDevice()"
            />
            <div
                v-if="edit"
                v-html="require('!html-loader!@/assets/icons/close_icon.svg')"
                class="d-inline-flex size-24"
                @click.stop.prevent="openDeleteDevice()"
            />
        </v-flex>
        <ModalMessage
            v-model="openDeleteDeviceModal"
            title="Удаление устройства"
            :text="deleteText"
            text-btn="Отменить"
            text-confirm-btn="Удалить"
            show-confirm-btn
            text-center
            @confirm="deleteDevice"
        />
        <ModalAddDevice
            v-if="openEditDeviceModal"
            v-model="openEditDeviceModal"
            :home="home.uid"
            :editDevice="device"
        />
    </v-layout>
</template>

<script>
import ModalAddDevice from "@/components/modals/ModalAddDevice";
import ModalMessage from "@/components/modals/ModalMessage";
export default {
    name: "DeviceStatus",
    components: {ModalAddDevice, ModalMessage},
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            show: false,
            showBattery: false,
            openEditDeviceModal: false,
            openDeleteDeviceModal: false,
            deleteText: "",
        };
    },
    computed: {
        edit() {
            return this.$store.getters.editMode;
        },
        home() {
            return this.$store.getters.home;
        },
        power() {
            if (this.device.state && this.device.state.power && this.device.state.power == "battery") {
                return this.device.state.battery < 11 ?
                    "empty" : this.device.state.battery < 16 ?
                        "low" : this.device.state.battery < 41 ?
                            "quarter" : this.device.state.battery < 61 ?
                                "half" : this.device.state.battery < 81 ?
                                    "most" : !this.device.state.battery ?
                                        "unknown" : "full";
            }
        },
    },
    methods: {
        openEditDevice() {
            this.openEditDeviceModal = true;
        },
        openDeleteDevice() {
            this.deleteText = `Вы действительно хотите удалить устройство ${this.device.name}?`;
            this.openDeleteDeviceModal = true;
        },
        deleteDevice() {
            this.$http.delete(`/devices/home/devices/${this.device.uid}/`)
                .then(() => {
                    this.close();
                    this.$emit("updateDeviceList");
                    this.openDeleteDeviceModal = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.cancel();
                });
        },
    },
}
</script>

<style lang="scss" scoped>
.status-marker {
    align-items: center;
    display: inline-flex;

    .green-color,
    .red-color {
        height: 12px;
        width: 12px;
        border-radius: 6px;
    }

    .green-color {
        background: #42D829;
    }

    .red-color {
        background: var(--rh-error-color);
    }
}

.v-tooltip__content {
    background: var(--rh-linear-gradient);
    border-radius: 30px;
    padding: 16px;

    &.menuable__content__active {
        opacity: 1;

        &.arrow-down {
            overflow: inherit !important;
            z-index: 7;

            &::before {
                content: '';
                position: absolute;
                left: 50%;
                top: 100%;
                border: 5px solid #FFC34F;
                border-color: #FFC34F transparent transparent transparent;
                opacity: 0.8;
            }
        }
    }
}
</style>